import { render } from "./LookupFiltersForm.vue?vue&type=template&id=28c8605a&ts=true"
import script from "./LookupFiltersForm.vue?vue&type=script&lang=ts"
export * from "./LookupFiltersForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__